import React, { useState, useEffect } from 'react'
import { Redirect } from "react-router-dom"
import NavBar from '../Components/NavBar/NavBar'
import { validateSession } from '../utils'
import { getIframeUrl } from '../services/getIframeUrl'


export default function Metabase() {
  const [iframeUrl, setIframeUrl] = useState('')

  useEffect(() => {
    const url = getIframeUrl()
    setIframeUrl(url)
    return () => {
    }
  }, [])
  

  if (!validateSession()) {
    return <Redirect to="/login" />
  }

  return (
    <>
      <NavBar />
      <iframe src={iframeUrl} title='Dashboard' style={{position: 'fixed', marginTop:'5%', border: 'none', width: '100vw', height: '100vh' }} />
    </>
  );
}
